import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "./scoped-merchant-client";

export const useCampaigns = (search: string) => {
  const scope = useScopedMerchantClient();

  return useQuery({
    queryKey: ["campaigns", scope.merchantId, scope.workspaceId, search],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].campaigns.$get({
            param: scope.param,
            query: { search },
          })
        : await client.merchant[":merchantId"].campaigns.$get({
            param: scope.param,
            query: { search },
          });

      if (!res.ok) throw await handleError(res);
      return res.json();
    },
    enabled: !!scope.merchantId,
  });
};
